import { Injectable } from '@angular/core';

import { doc, docData, collection, collectionData, Firestore, query, orderBy, where, addDoc, updateDoc, deleteDoc, setDoc, deleteField } from '@angular/fire/firestore';

import { map } from 'rxjs/operators';

import { Building } from '../classes/index';

@Injectable()
export class BuildingService {

	constructor(private firestore: Firestore) {
	}

	listBuildings(collectionPath) {
		return collectionData(query(collection(this.firestore, collectionPath)), { idField: 'id' })
		.pipe(map(collection => {
			return collection.map(data => {
				let item = new Building(collectionPath);
				item.fromJSON(data);
				return item;
			});
		}))
		.pipe(map(items => items.sort((a, b) => {
			if (a.labels['fr'] > b.labels['fr']) return 1;
			else if (a.labels['fr'] < b.labels['fr']) return -1;
			else return 0;
		})));
	}

	getBuildings(collectionPath){
		return collectionData(query(collection(this.firestore, collectionPath), orderBy('orderNum', 'asc')), { idField: 'id' })
		.pipe(map(collection => {
			return collection.map(data => {
				let item = new Building(collectionPath);
				item.fromJSON(data);
				return item;
			});
		}));
	}

	addBuilding(building) {
		let data = { ...building };
		delete data.collectionPath;
		return addDoc(collection(this.firestore, building.collectionPath), {...data});
	}

	setBuilding(building) {
		let data = { ...building };
		delete data.collectionPath;
		return setDoc(doc(this.firestore, building.collectionPath, building.id), data);
	}

	updateBuilding(building, data){
		data.collectionPath = deleteField();
		console.log('Update object:'+building.collectionPath+'/'+building.id);
		console.log('DATA:'+JSON.stringify(data));
		return updateDoc(doc(this.firestore, building.collectionPath, building.id), data);
	}

	deleteBuilding(building) {
		return deleteDoc(doc(this.firestore, building.collectionPath, building.id));
	}
}

